export default "__VITE_ASSET__BC$fBgiL__"